import { AccountTypeEnum } from 'api-hooks/transactions/transfer';
import HOCInput from 'components/common/hoc-input';
import { Input } from 'components/elements';
import BankAccountSelectInput from 'legacy-modules/master/bank-account/components/select-input';
import CashAccountSelectInput from 'legacy-modules/master/cash-account/components/select-input';
import { HalfContainer, SectionContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

interface props {
  tipType?: string;
}
export default function ApprovalTipDetail(props: props) {
  const { t } = useTranslation();
  const { tipType } = props;
  return (
    <>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="approvalable.transactionAt"
            label={t('common:date')}
          />
        </HalfContainer>
        {tipType === 'income' && (
          <HalfContainer>
            <Input
              type="date-time"
              name="approvalable.acknowledgedAt"
              label={t('common:acknowledged_at')}
            />
          </HalfContainer>
        )}
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="select"
            name="approvalable.accountType"
            label={t('common:account_type')}
            placeholder={t('common:account_type')}
            required
            options={[
              {
                id: AccountTypeEnum.bank,
                label: t(`common:${AccountTypeEnum.bank}`),
              },
              {
                id: AccountTypeEnum.cash,
                label: t(`common:${AccountTypeEnum.cash}`),
              },
            ]}
          />
        </HalfContainer>
        <HalfContainer>
          <HOCInput keys={[`approvalable.accountType`]}>
            {(values) => {
              const paymentMethod = values[`approvalable.accountType`];
              switch (paymentMethod) {
                case AccountTypeEnum.bank:
                  return (
                    <BankAccountSelectInput
                      name="approvalable.accountable"
                      required
                    />
                  );
                case AccountTypeEnum.cash:
                  return (
                    <CashAccountSelectInput
                      name="approvalable.accountable"
                      required
                    />
                  );
                default:
                  return <></>;
              }
            }}
          </HOCInput>
        </HalfContainer>
      </SectionContainer>

      <SectionContainer>
        <HalfContainer>
          <Input
            type="number"
            name="approvalable.amount"
            label={t('common:amount')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.description"
            label={t('common:description')}
          />
        </HalfContainer>
      </SectionContainer>
    </>
  );
}
